import Breadcrumb from "./widget/Breadcrumb";
import FooterThree from "./widget/FooterThree";
import HeaderOne from "./widget/HeaderOne";
import Animation from "../helper/Animation";
import RootLayout from "./layout";

const PrivacyPolicy = () => {
  return (
    <>
      <RootLayout>
        <Animation />

        <HeaderOne />

        {/* Breadcrumb */}
        <Breadcrumb title={"Privacy Policy"} />
        <section className="about-two py-60 position-relative z-1">
          <div className="position-relative">
            <div className="container">
              <div className="row gy-4 align-items-center">
                <div className="col-lg-12">
                  <div className="join-community__content">
                    <div className="mb-40">
                      <h2
                        className="mb-24"
                        data-aos="fade-up"
                        data-aos-duration="800"
                      >
                        INFORMATION WE COLLECT
                      </h2>
                      <p
                        className="text-neutral-500 text-line-2"
                        data-aos="fade-up"
                        data-aos-duration="800"
                        data-aos-delay="120"
                      >
                        Thank you for visiting the NATIONAL PUBLIC SCHOOL-KUDLU
                        website. At NATIONAL PUBLIC SCHOOL-KUDLU we are
                        committed to maintaining your trust by protecting
                        personal information we collect from you, and this
                        statement outlines the <b>School</b> policy on how the
                        <b>School</b> uses and manages personal data provided or
                        collected by the <b>School</b>.
                        <br />
                        <br />
                        <h5>PERSONAL INFORMATION</h5>
                        NATIONAL PUBLIC SCHOOL-KUDLU may collect the information
                        mentioned below directly during the admission process
                        which includes personal and sensitive information.
                        <ul>
                          <li>• Student’s name, Parents or Guardians name.</li>
                          <li>
                            • Email address, telephone or mobile number, postal
                            address, etc.
                          </li>
                          <li>
                            • Student’s age, Date of birth, details of family
                            members, siblings, etc.
                          </li>
                          <li>
                            • Contact information of relatives, friends, etc,
                            who come into contact with the school.
                          </li>
                          <li>
                            • Payment information, if payment information is
                            made through cheque, net banking, credit or debit
                            card, etc.
                          </li>
                          <li>• Medical ailment.</li>
                          <li>• Medical ailment.</li>
                        </ul>
                        <br />
                        <br />
                        <h5>INFORMATION TRANSFER</h5>
                        We limit access to personal information to those who
                        have a business need or third parties provided we
                        protect the information not to use the information for
                        any other purpose. We may disclose personal information
                        to government departments, medical practitioners, anyone
                        authorized by an individual to receive their
                        information, people providing service to the school,
                        including visiting teachers, sport coaches, etc. Any
                        information the NATIONAL PUBLIC SCHOOL-KUDLU collects
                        under the current website privacy policy will remain
                        subject to the terms of this website privacy policy.
                        After any changes take effect, all new information the
                        NATIONAL PUBLIC SCHOOL-KUDLU collects, will be subject
                        to the new policy.
                        <br />
                        <br />
                        <h5>COOKIES</h5>
                        The cookies are unique bits of computer data that many
                        major websites will transfer to your computer the first
                        time that you visit. Cookies are stored on your hard
                        drive and may be later accessed by the website to track
                        prior usage. Cookies may also be used to deliver
                        customized and personalized services and information by
                        tracking which pages a user has already visited. We do
                        not store any of your personal information in cookies,
                        web and beacons or other technologies on our computer.
                        Hence, you are not required to provide any personal
                        information through this website unless you choose to do
                        so. We cannot guarantee confidentiality of e-mails and
                        we therefore recommend that you do not send confidential
                        information via e-mail. If for any reason you are
                        concerned that the personal information available at
                        NATIONAL PUBLIC SCHOOL-KUDLU is not correct or needs to
                        be changed, you may please contact us at
                        info@npskudlu.com Email ID for the same.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <FooterThree />
      </RootLayout>
    </>
  );
};

export default PrivacyPolicy;
